<div class="text-text flex flex-col justify-start items-start gap-2 w-full h-screen " *ngIf="ready">


    <p class="text-white text-5xl">Centro notifiche</p>



    <div class="notifs-scroll  w-full rounded-3xl" style="max-height: 65%;">






        <div class=" w-full flex flex-col justify-start items-start" *ngIf="newNotif.length > 0">
            <h2 class="text-white my-5">Notifiche non lette</h2>



            <div *ngFor="let n of newNotif" class="w-full">

                <div
                    class="rounded-3xl bg-{{severityColorMap[n.severity]}}-700/30 gap-3  user-card p-4 flex justify-between items-center my-2 text-white">
                    <div class="flex flex-row justify-start items-center gap-5" [ngSwitch]="n.severity">

                        <div class="bg-red-500 rounded-full p-2"  *ngSwitchCase="'danger'">
                            <svg style="color: white;" xmlns="http://www.w3.org/2000/svg" fill="none"
                                viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </div>
                        <div class="bg-emerald-500 rounded-full p-2"  *ngSwitchCase="'success'">
                            <svg style="color: white;" xmlns="http://www.w3.org/2000/svg" fill="none"
                                viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5" />
                            </svg>
                        </div>
                        <div class="bg-amber-500 text-white rounded-full p-2"  *ngSwitchCase="'warning'">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round"
                                class="w-6 h-6">
                                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                <path d="M12 9v4" />
                                <path
                                    d="M10.363 3.591l-8.106 13.534a1.914 1.914 0 0 0 1.636 2.871h16.214a1.914 1.914 0 0 0 1.636 -2.87l-8.106 -13.536a1.914 1.914 0 0 0 -3.274 0z" />
                                <path d="M12 16h.01" />
                            </svg>
                        </div>

                        <div class="flex flex-col justify-start">
                            <p class="text-sm font-light text-white/70">{{n.date |date:"HH:mm"}}</p>
                            <p class="font-light text-white/70 text-sm">{{n.location}}</p>
                            <p class="font-semibold text-xl">{{n.title}}</p>
                            <p class="font-light text-lg">{{n.content}}</p>
                        </div>
                    </div>
                </div>


            </div>



        </div>

        <h2 *ngIf="oldNotif.length > 0 && newNotif.length > 0" class="text-white my-5">Notifiche vecchie </h2>
        <h2 *ngIf="oldNotif.length == 0"
            class="rounded-3xl bg-white/30  backdrop-blur-xl user-card text-white  p-4 gap-3 flex justify-between items-center m-1 font-medium text-lg">
            Nessuna notifica </h2>
        <div *ngFor="let date of days" class="flex flex-col justify-center items-center">
            <p class="text-xl my-5 rounded-3xl bg-primary-950 text-white w-full p-3 sticky top-0">{{date}}</p>
            <div *ngFor="let n of filterByDate(date)" style="width: 99%;">

                <div
                    class="rounded-3xl  bg-{{severityColorMap[n.severity]}}-700/30 user-card text-white  p-4 gap-3 flex justify-between items-center my-2 ">
                    <div class="flex flex-row justify-start items-center gap-5" [ngSwitch]="n.severity">

                        <div class="bg-red-500 rounded-full p-2"  *ngSwitchCase="'danger'">
                            <svg style="color: white;" xmlns="http://www.w3.org/2000/svg" fill="none"
                                viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </div>
                        <div class="bg-emerald-500 rounded-full p-2"  *ngSwitchCase="'success'">
                            <svg style="color: white;" xmlns="http://www.w3.org/2000/svg" fill="none"
                                viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5" />
                            </svg>
                        </div>
                        <div class="bg-amber-500 text-white rounded-full p-2"  *ngSwitchCase="'warning'">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round"
                                class="w-6 h-6">
                                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                <path d="M12 9v4" />
                                <path
                                    d="M10.363 3.591l-8.106 13.534a1.914 1.914 0 0 0 1.636 2.871h16.214a1.914 1.914 0 0 0 1.636 -2.87l-8.106 -13.536a1.914 1.914 0 0 0 -3.274 0z" />
                                <path d="M12 16h.01" />
                            </svg>
                        </div>
                        
                        <div class="flex flex-col justify-start">
                            <p class="text-sm font-light text-white/70">{{n.date |date:"HH:mm"}}</p>
                            <p class="font-light text-white/70 text-sm">{{n.location}}</p>
                            <p class="font-semibold text-xl">{{n.title}}</p>
                            <p class="font-light text-lg">{{n.content}}</p>
                        </div>
                    </div>
                </div>


            </div>
        </div>


    </div>





</div>